import { PropertyHelper } from '@/helpers/property.helper';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export class AttributeValueDialogData {
  attrCode: string;
  attrDisplayName: string;
}

export interface AttributeValueResult {
  attrCode: string,
  attrValue: string,
  attrDisplayName: string
}

@Component({
    selector: 'app-attribute-value-dialog',
    templateUrl: './attribute-value-dialog.component.html',
    styleUrls: ['./attribute-value-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, InputTrimDirective, NgIf, MatButtonModule]
})
export class AttributeValueDialogComponent implements OnInit {
  attrValueForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AttributeValueDialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AttributeValueDialogComponent>,
    public propHelper: PropertyHelper
  ) {
    this.dialogTitle = 'Entrez une valeur pour "' + this.data.attrDisplayName + '"';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.attrValueForm.get(field);
  }

  ngOnInit() {
    this.attrValueForm = this.fb.group({
      value: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.attrValueForm.valid) {
      this.formSubmitting = true;
      this.dialogRef.close({
        attrCode: this.data.attrCode,
        attrValue: this.f('value').value,
        attrDisplayName: this.data.attrDisplayName
      } as AttributeValueResult);
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
